export const CreateRegistrationApiEndpoints = {
  CREATE_REGISTRATION: "/registration-setting",
  REGISTRATION_LISTING: "/registration-setting/registration-detail-list",
  DELETE_REGISTRATION: "/registration-setting"
};
